module.exports = "/_next/static/images/26ce64dbca9722c98baa04c6ad665e77-recibir.svg.webp";